module.exports = __webpack_public_path__ + "media/images/bg/mosaic/sakura-7c4dda9396e4f0e1c3b518620e808d7e.svg";